import * as Sentry from "@sentry/react";
import packageJson from "../package.json";

function isLocalhost() {
  return window.location.hostname === "localhost";
}

export function initSentry() {
  Sentry.init({
    dsn: "https://e3fb91690b8446a0b9523f3ead111140@sentry.bale.sh/36",
    tracesSampleRate: 0.25,
    release: `tabligh-panel@${packageJson.version}+${process.env.REACT_APP_BUILD_NUMBER}`,
    allowUrls: [/.+.bale.ai.*/],
    dist: process.env.REACT_APP_BUILD_NUMBER,
    denyUrls: [/.*localhost.*/],
    environment: process.env.NODE_ENV,
    replaysSessionSampleRate: 0.1,
    integrations: [new Sentry.Replay()],
    replaysOnErrorSampleRate: 1.0,
    enabled: !isLocalhost(),
  });
}
